var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.875 2.3125H5.125C4.51187 2.31311 3.92404 2.55695 3.49049 2.99049C3.05695 3.42404 2.81311 4.01187 2.8125 4.625V32.375C2.81311 32.9881 3.05695 33.576 3.49049 34.0095C3.92404 34.4431 4.51187 34.6869 5.125 34.6875H32.875C33.488 34.6866 34.0757 34.4426 34.5092 34.0092C34.9426 33.5757 35.1866 32.988 35.1875 32.375V4.625C35.1869 4.01187 34.9431 3.42404 34.5095 2.99049C34.076 2.55695 33.4881 2.31311 32.875 2.3125ZM32.875 12.7188H16.6875V4.625H32.875V12.7188ZM14.375 4.625V12.7188H5.125V4.625H14.375ZM5.125 32.375V15.0312H32.875L32.8773 32.375H5.125Z",
    fill: "#8591A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDashboard);
export default __webpack_public_path__ + "static/media/ico_dashboard.6928a11efbccc2feb76ee626dd14d7d3.svg";
export { ForwardRef as ReactComponent };